import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alldoctor',
  templateUrl: './alldoctor.component.html',
  styleUrls: ['./alldoctor.component.css']
})
export class AlldoctorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
